import React from "react";

export default function Button({text, setShouldAnimate, setModelPosition}) {

    const handleButtonClick = () => {
        setShouldAnimate(true);
        setModelPosition(0);
    };

    return (
        <>
            <button onClick={handleButtonClick} className="btn-blue">{text}</button>
        </>
    )
}